<template>
  <div class="rc" :class="{ 'rc--danger': danger }">
    <div class="rc-title">{{ title }}</div>
    <p class="rc-text" v-if="text">{{ text }}</p>
    <textarea
      v-if="askReason"
      class="rc-input"
      v-model.trim="reason"
      rows="2"
      :placeholder="reasonRequired ? 'Why? Required — this is saved to the audit log.' : 'Why? Optional — saved to the audit log.'"
    ></textarea>
    <div class="rc-actions">
      <button class="rc-btn" type="button" @click="$emit('cancel')">Cancel</button>
      <button
        class="rc-btn rc-btn--go"
        type="button"
        :disabled="askReason && reasonRequired && !reason"
        @click="$emit('confirm', reason)"
      >{{ confirmLabel }}</button>
    </div>
  </div>
</template>

<script>
/**
 * An in-page confirmation with an optional reason, instead of window.prompt.
 * Used by every action that writes to the audit log: the reason is what the
 * log will show, so it is asked for right where the action is taken.
 */
export default {
  name: "ReasonConfirm",
  props: {
    title: { type: String, required: true },
    text: { type: String, default: "" },
    confirmLabel: { type: String, default: "Confirm" },
    askReason: { type: Boolean, default: true },
    reasonRequired: { type: Boolean, default: true },
    danger: { type: Boolean, default: false },
  },
  emits: ["confirm", "cancel"],
  data() {
    return { reason: "" };
  },
};
</script>

<style scoped>
.rc { width: 100%; box-sizing: border-box; padding: 18px 20px; border: 1px solid var(--accent-primary); border-radius: var(--r-lg); background: var(--accent-primary-bg); }
.rc--danger { border-color: var(--danger); background: var(--danger-bg); }
.rc-title { font-size: var(--t-body); line-height: var(--t-body-lh); font-weight: 600; color: var(--text-primary); }
.rc-text { margin: var(--s-1) 0 0; font-size: var(--t-body-sm); line-height: var(--t-body-sm-lh); color: var(--text-secondary); }
.rc-input { display: block; width: 100%; box-sizing: border-box; margin-top: var(--s-3); padding: var(--s-2) var(--s-3); font-size: var(--t-body-sm); font-family: inherit; border: 1px solid var(--border-primary); border-radius: 10px; background: var(--bg-input); color: var(--text-primary); resize: vertical; }
.rc-input:focus { outline: none; border-color: var(--border-input-focus); }
.rc-actions { display: flex; justify-content: flex-end; gap: var(--s-2); margin-top: var(--s-3); }
.rc-btn { font-size: var(--t-body-sm); font-weight: 600; padding: 8px 16px; border: 1px solid var(--border-primary); border-radius: 999px; background: var(--bg-primary); color: var(--text-secondary); cursor: pointer; }
.rc-btn--go { background: var(--btn-primary-bg); border-color: var(--btn-primary-bg); color: var(--btn-primary-text); font-weight: 600; }
.rc--danger .rc-btn--go { background: var(--danger); border-color: var(--danger); color: #fff; }
.rc-btn:disabled { opacity: 0.45; cursor: default; }
</style>
